export default "__VITE_ASSET__b1d16f25__"